/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import * as Yup from "yup";
import PrimaryButton from '../../../../Forms/PrimaryButton';

const route = 'resources/content/admin/tinyurls';
const basePath = '/content-feature/tinyurls';

const rootCss = css`
    max-width: 100%;

    .form-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        .save-btn-container {
            display: flex;
            margin-top: 100px !important;
        }
    }
`;

const validationSchema = Yup.object({
    tinyUrlId: Yup.number().required("Tiny Url Id is required"),
    tinyUrl: Yup.string()
        .required("Tiny url is required")
        .max(50, "Tiny url cannot exceed 50 characters"),
    redirectUrl: Yup.string()
        .required("Redirect url is required")
        .max(2000, "Redirect url cannot exceed 2000 characters"),
    platformId: Yup.number().required("This field is required"),
});

function mapInitialValues(data) {
    return data && Object.keys(data).length 
            ? { ...data } 
            : { tinyUrlId: 0, tinyUrl: "", redirectUrl: "", createdOn: "", platformId: 1 };
}

const successMsg = "Tiny Urls Updated.";

const setErrorMsg = (show, errors) => (
    show && Object.keys(errors).length > 0
        ? `Errors in: ${Object.keys(errors).join(', ')}. Check all required * fields.`
        : "Errors in form, check all required fields and try again."
);

const basicInfoFields = [
    { name: "tinyUrl", label: "Tiny Url", required: true },
    { name: "redirectUrl", label: "Redirect Url", required: true },
];

const platformOptions = [
    { key: 1, text: "iGrad" },
    { key: 2, text: "Enrich" },
  ];

const unsavedMsg = 'You have unsaved changes, are you sure you want to leave?';

const SaveButton = ({ handleSave, dirty, submitting }) => {
    return (
        <div className="save-btn-container">
            <PrimaryButton
                onClick={handleSave}
                text="Save"
                disabled={!dirty || submitting}
            />
        </div>
    );
};


export {
    route,
    basePath,
    rootCss,
    validationSchema,
    mapInitialValues,
    successMsg,
    setErrorMsg,
    basicInfoFields,
    platformOptions,
    unsavedMsg,
    SaveButton,
};